import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function CompletedModal({
  label,
  text,
  statement,
  modalstate,
  handleTerminate,
}) {
  return (
    <Backdrop
      open={modalstate}
      onClick={handleTerminate}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 2, alignItems: "flex-start", pt: { xs: 4, md: 8 } }}
    >
      <Paper
        onClick={(e) => e.stopPropagation()}
        elevation={4}
        sx={{ width: { xs: "92vw", sm: 440 }, borderRadius: "16px", p: 0, outline: "none" }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
            borderBottom: "1px solid #e5e7eb",
            borderRadius: "16px 16px 0 0",
          }}
        >
          <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>
            {label}
          </Typography>
          <IconButton size="small" onClick={handleTerminate} sx={{ color: "#6b7280" }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={{ p: 3 }}>
          {/* Success icon */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2.5 }}>
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                bgcolor: "#d1fae5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CheckCircleOutlineIcon sx={{ fontSize: 36, color: "#059669" }} />
            </Box>
          </Box>

          {/* Order ID / reference */}
          {text && (
            <Box
              sx={{
                bgcolor: "#f9fafb",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                px: 2,
                py: 1.25,
                mb: 2,
                textAlign: "center",
              }}
            >
              <Typography sx={{ fontSize: 11, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.08em", mb: 0.25 }}>
                Reference
              </Typography>
              <Typography sx={{ fontSize: 13, color: "#111827", fontWeight: 600, fontFamily: "monospace" }}>
                {text}
              </Typography>
            </Box>
          )}

          {/* Statement */}
          {statement && (
            <Typography sx={{ fontSize: 13, color: "#6b7280", textAlign: "center", lineHeight: 1.6, mb: 3 }}>
              {statement}
            </Typography>
          )}

          <Divider sx={{ mb: 2.5 }} />

          {/* Actions */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Box
              onClick={handleTerminate}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                py: 1.25,
                fontSize: 13,
                fontWeight: 600,
                borderRadius: "8px",
                cursor: "pointer",
                color: "#fff",
                bgcolor: "#194049",
                "&:hover": { bgcolor: "#0f2a31" },
                transition: "background 0.15s",
              }}
            >
              Go to Dashboard
            </Box>

            <Typography sx={{ fontSize: 11, color: "#9ca3af", textAlign: "center" }}>
              Redirecting automatically in 5 seconds…
            </Typography>
          </Box>
        </Box>
      </Paper>
    </Backdrop>
  );
}
